export const ModalChangeNicknameTranslationsCs = {
  changeNickname: 'Změnit přezdívku',
  Nickname: 'Přezdívka',
  saveButton: 'Uložit',
};
